import { Button, Card, CardBody, CardHeader, Col, FormGroup, Input, Label, PopoverBody, PopoverHeader, Row, Table, UncontrolledPopover, } from "reactstrap";
import { memo, useContext, useEffect, useState } from "react";
import styled from "styled-components";
import TableColumnSelectClient from "components/TableColumnSelectClient";
import SaveContact from "components/SaveContact";
import Api from "services/api";
import Paginate from "components/Paginate";
import { AuthContext } from "contexts/AuthContext";
import { useHistory } from "react-router-dom";
import ContactSendedList from "components/ContactsSendedList";
import { Progress } from "components/SaveContact/style";
import { ProgressBar } from "components/SaveContact/style";

import {HiChevronDown} from "react-icons/hi"
import { AgeSearch } from "components/ContactSearch";
import { AiOutlineLoading3Quarters } from "react-icons/ai";

const delay = ms => new Promise(resolve => setTimeout(resolve, ms))

const indexies = {
    name: {
        name: "NOME",
        key: 'name',
        use: false,
        usecol: true,
        Search: Input,
        index: false
    },
     
    birthdate: {
        name: "DATA NASCIMENTO",
        key: 'birthdate',
        usecol: true,
        use: false,
        Search: AgeSearch,
        index: false
    },
    client_cpf: {
        name: "CPF",
        key: "client_cpf",
        usecol: true,
        use: false,
        Search: Input,
        index: false
    },
    rg: {
        name: "RG",
        usecol: true,
        use: false,
        key: 'rg',
        Search: Input,
        index: false
    },
    genero: {
        name: "GÊNERO",
        usecol: true,
        use: false,
        key: 'genero',
        Search: Input,
        index: false
    },
    name_author: {
        name: "NOME RESPONSÁVEL",
        key: 'name_author',
        usecol: true,
        use: false,
        Search: Input,
        index: false
    },
    cpf_author: {
        name: "CPF RESPONSÁVEL",
        key: 'cpf_author',
        usecol: false,
        use: false,
        Search: Input,
        index: false
    },

    bairro: {
        name: "BAIRRO",
        key: 'bairro',
        usecol: false,
        use: false,
        Search: Input,
        index: false
    },
    cidade: {
        name: "CIDADE",
        key: 'cidade',
        usecol: false,
        use: false,
        Search: Input,
        index: false
    },
    uf: {
        name: "UF (ESTADO)",
        key: 'uf',
        use: false,
        usecol: false,
        Search: Input,
        index: false
    },
    cep: {
        name: "CEP",
        key: 'cep',
        use: false,
        usecol: false,
        Search: Input,
        index: false
    },
    numero: {
        name: "NUMERO DA CASA",
        key: 'numero',
        use: false,
        usecol: false,
        Search: Input,
        index: false
    },
    logradouro: {
        name: "LOGRADOURO",
        key: 'logradouro',
        use: false,
        usecol: false,
        Search: Input,
        index: false
    },
    ddd: {
        name: "DDD",
        key: 'ddd',
        arr: [],
        usecol: false,
        use: false,
        Search: Input,
        index: false
    },
    cel: {
        name: "CELULAR 1",
        key: 'cel',
        arr: [],
        usecol: false,
        use: false,
        Search: Input,
        index: false
    },
    cel2: {
        name: "CELULAR 2",
        key: 'cel2',
        arr: [],
        usecol: false,
        use: false,
        Search: Input,
        index: false
    },
    cel3: {
        name: "CELULAR 3",
        key: 'cel3',
        arr: [],
        usecol: false,
        use: false,
        Search: Input,
        index: false
    },
    cel4: {
        name: "CELULAR 4",
        key: 'cel4',
        arr: [],
        usecol: false,
        use: false,
        Search: Input,
        index: false
    },
    cel5: {
        name: "CELULAR 5",
        key: 'cel5',
        arr: [],
        usecol: false,
        use: false,
        Search: Input,
        index: false
    },
    email: {
        name: "EMAIL",
        key: 'email',
        use: false,
        usecol: false,
        Search: Input,
        index: false
    }
}

const getKeys = (json) => {
    let j = {}
    for (const key in json) {
        j[key] = {
            usecol: json[key].usecol
        }
    }
    return j
}
const getKeys2 = (json) => {
    let j = {}
    for (const key in json) {
        j[key] = ""
    }
    return j
}

function ClientesAdmin(){
    const history = useHistory();

    const [fields, setFields] = useContext(AuthContext);

    const [contacts, setContacts] = useState({
        queried: false,
        searched: false,
        page: 2,
        limit: 10,
        count: 0,
        list: []
    });

    const [column, setColumn] = useState({
        ...getKeys(indexies)
    })

    const [uploadProgress, setUploadProgress] = useState(0);

    const [upload, setUpload] = useState({
        file: "",
        status: false
    });

    const [contactFields, setContactFields] = useState({
        indexies: indexies,
        step: 1,
        sendlist: false,
        contactfile: false,
        filesize: 0,
        serverfile: "",
        filename: "",
        filetype: "Bytes",
        filetype: "Bytes",
        cols: [],
        rows: [],
        contacts: [],
        columns: []
    });

    const [search, setSearch] = useState({
        ...getKeys2(indexies),
        minAge: "",
        maxAge: "",
        kms: "",
        geo: false,
        adressType: "adress"
    });

    const [drag, setDrag] = useState(false);
    
    const setIndexies = (indexies, columns) =>{
        setContactFields({...contactFields, indexies, columns})
    }
    
    const setColumns = (cols) =>{
        setContactFields({...contactFields, columns: cols})
    }
    function percentage(partialValue, totalValue) {
        return (100 * partialValue) / totalValue;
    }

    const resetContactFields = () => {
        setContactFields({
            indexies: indexies,
            step: 1,
            sendlist: false,
            contactfile: false,
            filesize: 0,
            serverfile: "",
            filename: "",
            filetype: "Bytes",
            filetype: "Bytes",
            cols: [],
            rows: [],
            contacts: [],
            columns: []
        })
    }
    
    const setStep = (step) =>{
        setContactFields({...contactFields, step})
    }

    const getSearch = (value, name) => {
        if(name === "cel" || name=== "tel" || name=== "client_cpf" || name === "kms" || name == "minAge" || name == "maxAge"){
            value = value.replace(/[^0-9]+/g, "");
        }
        setSearch({...search, [name]: value})
    }

    const canSearch = () => {
        const keys = Object.keys(getKeys2(indexies));
        let can = false;
        for (let i = 0; i < keys.length; i++) {
            if(search[keys[i]]!="") {
                can = true
            }
        }

        if(search.minAge != "" || search.maxAge != "" || search.kms) {
            can = true
        }
        return can
    }

    const parseCols = (cols) => {
        return cols.map((i,k)=>{
            return {
                index: k,
                name: i,
                wpp: false,
                use: false,
                key: "none"
            }
        })
    }

    const createSLXArray = (xls, file) => {
        let columns = [];
        let rows    = [];
        if(xls[0]) {
            const obj = xls[0];
            Object.keys(obj).forEach(key => {
                columns.push(key);
            });
            for (let i = 0; i < xls.length; i++) {
                const row = xls[i];
                let _row = [];
                Object.keys(row ).forEach(key => {
                    _row.push(row[key])
                });
                rows.push(_row);
            }
        }
        setContactFields({...contactFields, contactfile: file, cols: columns, columns: parseCols(columns), rows, contacts: [[...columns], ...rows]});
    }

    const makeContacts = (data) => {
        console.log("data:",data);
        let columns = [];
        let rows    = [];
        for (let i = 0; i < data.length; i++) {
            const client = data[i];
            if(rows.length === 0) {
                let cols = [];
                for (const k in client) {
                    if(indexies[k]) {
                        cols.push(indexies[k].name)
                    }
                }
                columns = cols;
            }
            let _rows = [];
            for (const k in client) {
                if(indexies[k]) {
                    _rows.push(client[k])
                }
            }
            rows.push(_rows);
        }
        setFields({...fields, hasContacts: true, contactfile: true, cols: columns, columns: parseCols(columns), rows, contacts: [[...columns], ...rows]});
        history.push("/admin/message")
    }

    const SendMsgs = async () => {
        try {
            const res = await Api("post", `contact/search?full=true`, {...search}, {
                headers: {
                    "x-access-token": localStorage.getItem("terces")
                }
            });
            if(res.data){
                makeContacts(res.data.list);
            }
        } catch (error) {
            console.log("SendMsgs error:",error);
        }
    }

    const onChangeFile = (file) => {
        let filetype = "Bytes";
        let filesize = file.size;
        if(filesize > 1024) {
            filesize = file.size / 1024;
            filetype = "KB";
        }
        if(filetype == "KB" && filesize > 1024) {
            filesize = filesize / 1024;
            filetype = "MB";
        }

        setContactFields({...contactFields, contactfile: file, filesize: filesize.toFixed(2), filetype, filename: file.name})
    }

    const searchContacts = async() => {
        try {
            const res = await Api("post", `contact/search?limit=${contacts.limit}&page=${1}`, {...search}, {
                headers: {
                    "x-access-token": localStorage.getItem("terces")
                }
            });
            if(res.data){
                setContacts({...res.data, searched: true, queried: true});
            }
        } catch (error) {
            console.log("getContacts error:",error);
            setContacts({...contacts, queried: true});
        }
    }

    const waitUploadReturnCols = async() => {
        await delay(1000);
        try {
            const res = await Api("post", `contact/getcols`, {file: upload.file}, {
                headers: {
                    "x-access-token": localStorage.getItem("terces")
                }
            });
            console.log("waitUploadReturnCols:",res);
            if(res.data.status === "reading") {
                waitUploadReturnCols();
            } else if(res.data.status === "done") {
                setUpload({...upload,...res.data})
            }
        } catch (error) {
            console.log("getContacts error:",error);
        }
    }

    const sendFile = async () => {
        let form = new FormData();
        const fileSize = contactFields.contactfile.size;
        form.append("contactfile", contactFields.contactfile)
        try {
            const res = await Api("post", `contact/upload`, form, {
                headers: {
                    "x-access-token": localStorage.getItem("terces")
                },
                onUploadProgress: progressEvent => {
                    setUploadProgress(percentage(progressEvent.loaded, progressEvent.loaded >= fileSize ? progressEvent.loaded : fileSize))
                }
            });
            console.log("sendFile:",res.data);
            if(res.data){
                setUpload(res.data);
            }
        } catch (error) {
            console.log("getContacts error:",error);
        }
    }

    function percentage(partialValue, totalValue) {
        return (100 * partialValue) / totalValue;
    }
    

    const getContacts = async(page = 1) => {
        if(!contacts.searched){
            try {
                const res = await Api("get", `contact/list?limit=${contacts.limit}&page=${page}`, {
                    headers: {
                        "x-access-token": localStorage.getItem("terces")
                    }
                });
                if(res.data){
                    setContacts({...res.data, queried: true, searched: contacts.searched});
                }
            } catch (error) {
                console.log("getContacts error:",error);
                setContacts({...contacts, queried: true});
            }
        } else {
            try {
                const res = await Api("post", `contact/search?limit=${contacts.limit}&page=${page}`, {...search}, {
                    headers: {
                        "x-access-token": localStorage.getItem("terces")
                    }
                });
                if(res.data){
                    setContacts({...res.data, searched: true, queried: true});
                }
            } catch (error) {
                console.log("getContacts error:",error);
                setContacts({...contacts, queried: true});
            }
        }
    }


    useEffect(()=>{
        if(upload.status==="reading") {
            waitUploadReturnCols();
        } else if(upload.status==="done") {
            setContactFields({...contactFields, cols: upload.cols, columns: parseCols(upload.cols), serverfile: upload.file});
            setUpload({status: false, file: ""})
        }
    },[upload]);

    useEffect(()=>{
        if(!contacts.queried) {
            getContacts();
        }
    },[contacts]);

    if(contactFields.sendlist) {
        return <ContactSendedList contactFields={contactFields} setContactFields={setContactFields}/>
    }

    if(contactFields.step===1) {
        return (
            <div className="content">
                <Row>
                    <Col md="12">
                        <Card>
                            <CardHeader>
                                <h1>Clientes: {contacts.count}</h1>
                            </CardHeader>
                            <CardBody>
                                <Row>
                                    <Col> 
                                        <Button onClick={ () => setContactFields({...contactFields, step: 2}) } className="btn-fill" color="primary">Adicionar Usuários</Button> 
                                        <Button onClick={ () => setContactFields({...contactFields, sendlist: true}) } className="btn-fill" color="warning">Listas enviadas</Button> 
                                        {
                                            (contacts.searched && contacts.count) &&
                                            <Button onClick={ () => SendMsgs() } className="btn-fill" color="info">Enviar mensagens para estes contatos</Button> 
                                        }
                                    </Col>
                                </Row>
                                <Row>
                                    <Col>
                                        <Table>
                                            <thead>
                                                <tr>
                                                    <th>
                                                        <Row>
                                                            <Col md="6"></Col>
                                                            <Col>
                                                                <PopoverButton id="PopoverClick"><div>Colunas<span><HiChevronDown/></span></div></PopoverButton>
                                                                <UncontrolledPopover
                                                                    placement="bottom"
                                                                    target="PopoverClick"
                                                                    trigger="click">
                                                                    <PopoverBody>
                                                                        <div style={{
                                                                            maxHeight: 300,
                                                                            overflowY: "auto"
                                                                        }}>
                                                                            <Table>
                                                                                <tbody>
                                                                                    {
                                                                                        Object.keys(indexies).map(i => (
                                                                                            <tr key={"tbody-r-"+i}>
                                                                                                <th>
                                                                                                    <FormGroup check>
                                                                                                        <Label check>
                                                                                                            <input {...(column[i].usecol ? {checked: true} : {})}
                                                                                                                defaultValue={column[i].usecol}
                                                                                                                type="checkbox"
                                                                                                                onChange={(e) => setColumn({...column, [i]: {
                                                                                                                    usecol: !column[i].usecol,

                                                                                                                }})}
                                                                                                                />
                                                                                                            <span className="form-check-sign">
                                                                                                            </span>
                                                                                                        </Label>
                                                                                                    </FormGroup>
                                                                                                </th>
                                                                                                <th>{indexies[i].name}</th>
                                                                                            </tr>
                                                                                        ))
                                                                                    }
                                                                                </tbody>
                                                                            </Table>
                                                                        </div>
                                                                    </PopoverBody>
                                                                </UncontrolledPopover>
                                                            </Col>
                                                            <Col>
                                                                <Input value={search.kms} onChange={e => getSearch(e.target.value, "kms")} style={ {border: "1px solid #f5f5f5"}} type="text" placeholder={'Distância em km'}/>
                                                            </Col>
                                                            <Col>
                                                                <Button disabled={!canSearch()} color="primary" onClick={ () => searchContacts() }>Pesquisar</Button>
                                                            </Col>
                                                        </Row>
                                                    </th>
                                                </tr>
                                            </thead>
                                        </Table>
                                    </Col>
                                </Row>
                                <p className="mt-1">Pagina: {contacts.page} de {Math.ceil(parseInt(contacts.count) / parseInt(contacts.limit))}</p>
                                <Table>
                                    <thead className="text-primary">
                                    <tr>
                                        {
                                            Object.keys(column).map( i => {
                                                const Search = indexies[i].Search
                                                return (
                                                    column[i].usecol && 
                                                    <th>
                                                        {
                                                            <Search value={search[i]} search={search} getSearch={getSearch} onChange={e => getSearch(e.target.value, i)}  style={ !search.geo ? {border: "1px solid #f5f5f5"} : {}} type="text" placeholder={"Pesquisar "+indexies[i].name.toLowerCase()}/>
                                                        }
                                                    </th>
                                                )
                                            })
                                        }
                                    </tr>
                                    <tr>
                                        {
                                            Object.keys(column).map( i => (
                                                column[i].usecol &&
                                                <th key={"thead-name-r-"+i} style={{color: "#f1f1f1"}}>{indexies[i].name}</th>
                                            ))
                                        }
                                    </tr>
                                    </thead>
                                    <tbody>
                                        {contacts.list.map(contact => (
                                            <tr key={contact._id}>
                                                {
                                                    Object.keys(column).map( i => (
                                                        column[i].usecol &&
                                                        <td key={"tbody-input-r-"+i+"-"+contact._id} style={{color: "#f1f1f1"}}>{contact[i] && contact[i]}</td>
                                                    ))
                                                }
                                            </tr>
                                        ))}
                                    </tbody>
                                </Table>
                                {
                                    contacts.queried &&
                                    <Paginate getContacts={getContacts} setContacts={setContacts} contacts={contacts}/>
                                }
                            </CardBody>
                        </Card>
                    </Col>  
                </Row>
            </div>
        )
    }

    if(contactFields.step === 2) {
        return (
            <div className="content">
                <Row>
                    <Col>
                        <Card>
                            <CardBody>
                                <InputFile>
                                    <label>
                                        <input
                                            style={{display: 'none'}}
                                            type="file"
                                            name="contactfile"
                                            onChange={(e)=> onChangeFile(e.target.files[0])} />
                                        <InputBtn selected={!!contactFields.contactfile} className="input-btn"> {!!contactFields.contactfile ? <> <i className="tim-icons icon-check-2"></i> Arquivo selecionado </> : "Escolher Arquivo" }</InputBtn>
                                        <span className="input-txt">{ contactFields.contactfile ? contactFields.contactfile.name : 'Nenhum arquivo escolhido' }</span>
                                    </label>
                                </InputFile>
                                <div style={{
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        padding: 25,
                                        border: drag ? "1px dashed green"  : `1px dashed #f5f5f5`,
                                        
                                    }} onDragOver={(e)=>{
                                        let event = e ;
                                        event.stopPropagation();
                                        event.preventDefault();
                                        setDrag(true)
                                    }} onDragLeave={()=>{
                                        setDrag(false)
                                    }}
    
                                    onDrop={(e)=>{
                                        var file = e.dataTransfer.items[0].getAsFile();
                                        e.stopPropagation();
                                        e.preventDefault();
                                        setDrag(false)
                                        onChangeFile(file)
                                    }}>
                                    <span
                                    style={{
                                        color: "#fff"
                                    }}>{drag ? "Soltar" : "Solte um Arquivo Aqui"}</span>
                                </div>
                            </CardBody>
                        </Card>
                    </Col>
                    <Col md="6">
                        <Card>
                            <CardBody>
                                {
                                    contactFields.contactfile &&
                                    <Table>
                                        <thead>
                                            <tr>
                                                <th>Nome:</th>
                                                <th>{contactFields.contactfile.name}</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td>Tamanho:</td>
                                                <td>{contactFields.filesize}{contactFields.filetype}</td>
                                            </tr>
                                        </tbody>
                                    </Table>
                                }
                                {
                                    uploadProgress > 0 && uploadProgress < 100 &&
                                    <p style={{fontSize: 24}}>Progresso: {parseInt(uploadProgress)}%</p>
                                }
                                {
                                    uploadProgress == 100 && !upload.status?
                                    <p style={{fontSize: 24}}>Enviado com successo!</p>
                                    : null
                                }
                                {
                                    upload.status == "reading" &&
                                    <p style={{fontSize: 24}}>Processando Arquivo <IconLoader><AiOutlineLoading3Quarters/></IconLoader></p>
                                }
                                <ProgressBar>
                                    <Progress progress={parseInt(uploadProgress)}/>
                                </ProgressBar>

                                <Button disabled={uploadProgress || contactFields.serverfile != ""} color="primary" onClick={(e)=>sendFile()}>Enviar</Button>
                                <Button onClick={()=>setContactFields({...contactFields, step: 3})} disabled={!contactFields.cols.length} color="primary">Próximo</Button>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </div>
        )
    }
    if(contactFields.step === 3) {
        return (
            <div className="content">
                <Row>
                    <Col>
                        <Card>
                            <CardBody>
                                <TableColumnSelectClient resetContactFields={resetContactFields} setStep={setStep} setIndexies={setIndexies} setContactFields={setContactFields} contactFields={contactFields} setColumns={setColumns}/>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </div>
        )
    }
    return (
        <SaveContact setContactFields={setContactFields} contactFields={contactFields}/>
    )
}

const IconLoader = styled.span`
    @keyframes lds-ring {
        0% {
            transform: rotate(0deg);
        }
        100% {
            transform: rotate(360deg);
        }
    }
    svg {
        animation: lds-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
        color: #e14eca;
    }
`;

const InputFile = styled.div`
    padding: 4px 16px;
    label {
        width: 100%;
        height: auto;
    }
    .input-btn {

    }
    .input-txt {
        border: 1px solid rgba(255, 255, 255, .1);
        padding: 4px 12px;
    }
`;

const PopoverButton = styled.div`
    display: inline-block;
    padding: 8px 24px;
    background-color: #fff;
    border-radius: 3px;
    color: #000;
    float: right;
    div {
        display: flex;
        align-items: center;
        justify-content: center;
    }
    svg {
        margin-left: 12px;
        font-size: 20px;
    }
`;


const InputBtn = styled.span`
    color: ${p => p.selected ? "#fff" : "#444"};;
    padding: 4px 12px;
    background-color: ${p => p.selected ? "#0e7c1c" : "#fff"};
`;

export default memo(ClientesAdmin)